import React from 'react';
import SafePage from '../../components/safePage';
import SubHeader from '../../../../sites/plans/components/subHeader';
import SafecheckPhone from '../../components/pages/safeCheckPhone';

async function action(params, props) {
  return {
    title: 'SafeCheck Phone',
    component: (
      <SafePage {...props}>
        <SubHeader traveler={true} />
        <SafecheckPhone />
      </SafePage>
    ),
  };
}

export default action;

